import { getAuthHeaders } from '../utils/authHeaders';

const API_URL = 'https://app.pvslimited.co.uk/api';

const formatAddress = (address) => {
  return `${address.buildingNumber}, ${address.street}, ${address.town}, ${address.postcode}`;
};

const sendEmail = async (formData) => {
    const htmlContent = `
      <html>
        <body>
          <h2>Tank Movement Form Submission</h2>
          <p style="font-size: 11px; color: #666; margin: 0 0 10px 0;">Ref: PVS-TMF-001 | Version: 1.0</p>
          <table border="1" cellpadding="5" style="border-collapse: collapse;">
            <tr>
              <td>From:</td>
              <td>${formatAddress(formData.deliveryFrom)}</td>
            </tr>
            <tr>
              <td>To:</td>
              <td>${formatAddress(formData.deliveryTo)}</td>
            </tr>
            <tr>
              <td>Date:</td>
              <td>${formData.date}</td>
            </tr>
            <tr>
              <td>Job Type:</td>
              <td>${formData.jobType}</td>
            </tr>
            <tr>
              <td>Installation Type:</td>
              <td>${formData.installationType}</td>
            </tr>
            <tr>
              <td>Type of Test:</td>
              <td>${formData.typeOfTest}</td>
            </tr>
            <tr>
              <th colspan="2">Vessels</th>
            </tr>
            ${formData.vessels.map((vessel, index) => `
              <tr>
                <td colspan="2">
                  <strong>Vessel ${index + 1}:</strong><br>
                  Size: ${vessel.size}<br>
                  Quantity: ${vessel.quantity}<br>
                  Installation: ${vessel.isAboveground ? 'Aboveground' : 'Underground'}<br>
                  Serial Number: ${vessel.serialNumber}
                </td>
              </tr>
            `).join('')}
            <tr>
              <td>Job Description:</td>
              <td>${formData.jobDescription}</td>
            </tr>
            <tr>
              <td>Parts Used:</td>
              <td>${formData.partsUsed || 'None'}</td>
            </tr>
            <tr>
              <td>Tightness Test Complete:</td>
              <td>${formData.tightnessTestComplete ? 'Yes' : 'No'}</td>
            </tr>
            <tr>
              <td>Job Status:</td>
              <td>${formData.jobComplete ? 'Complete' : 'Incomplete'}</td>
            </tr>
          </table>
        </body>
      </html>
    `;

  try {
    const response = await fetch(`${API_URL}/send-email`, {
      method: 'POST',
      headers: getAuthHeaders(true),
      body: JSON.stringify({
        to: 'forms@pvslimited.com',
        subject: 'Tank Movement Form Submission',
        html: htmlContent
      })
    });

    if (!response.ok) throw new Error('Failed to send email');
    return true;
  } catch (error) {
    console.error('Email sending failed:', error);
    return false;
  }
};

export default sendEmail;